import script from "./theme-gallery4.vue?vue&type=script&lang=js"
export * from "./theme-gallery4.vue?vue&type=script&lang=js"

import "./theme-gallery4.vue?vue&type=style&index=0&id=4b96c854&lang=css"

const __exports__ = script;

export default __exports__